import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";

ReactSession.setStoreType("localStorage");


const Customers = () => {
    const userId=ReactSession.get("welbeingId");
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
   
    const [error, setError] = useState(null);
    const limit = 10;

    const [page, setPage] = useState(1);
       const [rowsPerPage2, setRowsPerPage2] = useState(10); // Items per page
      
      // Calculate total pages
    
      if(userId  <= 0 ){
          navigate('/login');
       }
      
      
      const handlePageChange = (event, newPage) => {
        event.preventDefault();
        if (newPage >= 1 && newPage <= totalPages) {
          setPage(newPage);
        }
      };
      
      const totalPages = Math.ceil(customers.length / rowsPerPage2);
      const currentData = customers.slice(
        (page - 1) * rowsPerPage2, 
        page * rowsPerPage2
      );



   
    useEffect(() => {
        const fetchCustomers = async () => {

            const response = await fetch(`https://projects.sninfoserv.com/welb-api/admin/customer/get-customer/`);
            const data = await response.json();
            console.log("Response", response.data);
            setCustomers(data.data);
        };
        fetchCustomers().catch(error => {
            setError(error.message);
        });

    }, []);

    


    return (
        <>
            <Header />
         
            <div className="container-fluid">
                <div className="card bg-light-info shadow-none position-relative overflow-hidden">
                    <div className="card-body px-4 py-3">
                        <div className="row align-items-center">
                            <div className="col-9">
                                <h4 className="fw-semibold mb-8">All Customers</h4>
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a className="text-muted" href="/dashboard">Dashboard</a></li>
                                        <li className="breadcrumb-item" aria-current="page">Customers</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <section>
                    <div className="row">
                        <div className="col-12">
                            <div className="card" style={{paddingLeft:'260px'}}>
                                <div className="card-body">
                                    <div className="mb-2">
                                        <h5 className="mb-0">File export</h5>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table border table-striped table-bordered" style={{ tableLayout: 'fixed' }}>
                                            <colgroup>
                                                <col className="col-md-2" />
                                                <col className="col-md-1" />
                                                <col className="col-md-3" />
                                                <col className="col-md-2" />
                                                <col className="col-md-2" />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>Customer</th>
                                                    <th>Gender</th>
                                                    <th>Email</th>
                                                    <th>Phone</th>
                                                    <th>Password</th>
                                                    {/* <th>View</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentData?.slice().reverse().map((customer) => (
                                                    <tr key={customer.cust_id}>
                                                        <td className="text-truncate">
                                                            <div className="d-flex align-items-center">
                                                                <img
                                                                    src={"https://projects.sninfoserv.com/welb-api/admin/uploads/" + customer.profile}
                                                                    className="rounded-circle"
                                                                    width={40}
                                                                    height={40}
                                                                    alt={customer.name}
                                                                />
                                                                <div className="ms-3">
                                                                    <h6 className="mb-0">{customer.name}</h6>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="text-truncate">{customer.gender}</td>
                                                        <td className="text-truncate">{customer.email}</td>
                                                        <td className="text-truncate">{customer.phonenumber}</td>
                                                        <td className="text-truncate">{customer.password}</td>
                                                        {/* <td align="left"><div class="btn-group"><a type="button" class="btn btn-success bg-gradient-success" href="#"><i class="ti ti-eye"></i></a></div></td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                     {/* Pagination component */}
                                                                  
                                                                         <div className="row">
                                                                             <div className="col-12">
                                                                               <nav>
                                                                                 <ul className="pagination justify-content-end">
                                                                                   {/* Previous */}
                                                                                   <li className={page === 1 ? "page-item disabled" : "page-item"}>
                                                                                     <button 
                                                                                       className="page-link" 
                                                                                       onClick={(e) => handlePageChange(e, page - 1)}
                                                                                       disabled={page === 1}
                                                                                     >
                                                                                       « Previous
                                                                                     </button>
                                                                                   </li>
                                                                           
                                                                           
                                                                                   {/* Visible page numbers */}
                                                                                   {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                                                     .filter(p => p === 1 || p === totalPages || Math.abs(page - p) <= 2)
                                                                                     .map(p => (
                                                                                       <li key={p} className={page === p ? "page-item active" : "page-item"}>
                                                                                         <button className="page-link" onClick={(e) => handlePageChange(e, p)}>
                                                                                           {p}
                                                                                         </button>
                                                                                       </li>
                                                                                     ))}
                                                                           
                                                                                   {/* Show ... and last page if current page < totalPages - 2 */}
                                                                                   {page < totalPages - 2 && (
                                                                                     <>
                                                                                       <li className="page-item disabled">
                                                                                         <span className="page-link">...</span>
                                                                                       </li>
                                                                                       <li className="page-item">
                                                                                         <button className="page-link" onClick={(e) => handlePageChange(e, totalPages)}>
                                                                                           {totalPages}
                                                                                         </button>
                                                                                       </li>
                                                                                     </>
                                                                                   )}
                                                                           
                                                                                   {/* Next */}
                                                                                   <li className={page === totalPages ? "page-item disabled" : "page-item"}>
                                                                                     <button 
                                                                                       className="page-link" 
                                                                                       onClick={(e) => handlePageChange(e, page + 1)}
                                                                                       disabled={page === totalPages}
                                                                                     >
                                                                                       Next »
                                                                                     </button>
                                                                                   </li>
                                                                                 </ul>
                                                                               </nav>
                                                                             </div>
                                                                        </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </>
    );
}

export default Customers;